import React from 'react';
import { connect } from 'react-redux';
import { Card, CardText, CardMedia, Menu, MenuItem, IconButton, Popover } from 'material-ui';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import get from 'lodash/get';
import { TextBlock } from 'react-placeholder/lib/placeholders';
import moment from 'moment';
import { getEntities } from 'dash-front/selectors';
import { LOADING_CLASSNAME, LOADING_COLOR } from 'dash-front/constants';
import { addToQuery } from 'dash-front/helpers';
import PostImage from './PostImage';
import PostStatus from './PostStatus';
import PostActionButtons from './PostActions';

const CARD_WIDTH = 400;
const IMAGE_HEIGHT = 250;

class PostActions extends React.PureComponent {
    state = {
        open: false,
        anchorEl: null
    };

    handleTouchTap = event => {
        event.preventDefault();
        this.setState({
            open: true,
            anchorEl: event.currentTarget
        });
    };

    handleRequestClose = () => {
        this.setState({ open: false });
    };

    openLogs = () => {
        addToQuery('logs', this.props.postId);
        this.handleRequestClose();
    };

    render() {
        return (
            <div>
                <IconButton onTouchTap={this.handleTouchTap}>
                    <MoreVertIcon color="white" />
                </IconButton>
                <Popover
                    open={this.state.open}
                    anchorEl={this.state.anchorEl}
                    anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                    targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                    onRequestClose={this.handleRequestClose}
                >
                    <Menu>
                        <MenuItem primaryText="Logs" onTouchTap={this.openLogs} />
                    </Menu>
                </Popover>
            </div>
        );
    }
}

const Post = connect((state, { id }) => ({
    post: id ? get(getEntities(state)['posts'], id) : null
}))(
    class _Post extends React.PureComponent {
        renderText() {
            const { post } = this.props;
            const loaded = Boolean(post);
            if (!loaded) {
                return <TextBlock rows={5} className={LOADING_CLASSNAME} color={LOADING_COLOR} />;
            }
            return (
                <div>
                    <p>Last updated: {moment(post.updatedAt).fromNow()}</p>
                    <p>
                        Status: <PostStatus post={post} />
                    </p>
                    <div>
                        <PostActionButtons post={post} />
                    </div>
                </div>
            );
        }

        render() {
            const { post } = this.props;
            const loaded = Boolean(post);

            return (
                <div>
                    <Card style={{ width: CARD_WIDTH }}>
                        {loaded ? (
                            <div style={{ position: 'relative' }}>
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        right: 0,
                                        zIndex: 10
                                    }}
                                >
                                    <PostActions postId={this.props.id} />
                                </div>
                            </div>
                        ) : null}
                        <CardMedia>
                            <PostImage post={post} width={CARD_WIDTH} height={IMAGE_HEIGHT} />
                        </CardMedia>
                        <CardText>{this.renderText()}</CardText>
                    </Card>
                </div>
            );
        }
    }
);

export default Post;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/Posts/NotPublishedPost.js
 **/